import { style } from '@vanilla-extract/css'

import { getRgba } from '~/styles/mixins/color.css'
import { getFontSize } from '~/styles/mixins/font.css'
import { getMediaQuery } from '~/styles/mixins/mediaQuery.css'
import { cssVariables } from '~/styles/variables/cssVariables.css'

export const layoutPopupMessage = style({
  position: 'fixed',
  zIndex: cssVariables.zIndex.popupMessage.base,
  top: 72,
  right: 0,
  width: '100%',
  maxWidth: `calc(240px + (${cssVariables.layout.inner.padding.xs} * 2))`,
  padding: `0 ${cssVariables.layout.inner.padding.xs}`,

  '@media': {
    [getMediaQuery('sm')]: {
      top: 80,
      maxWidth: `calc(240px + (${cssVariables.layout.inner.padding.sm} * 2))`,
      padding: `0 ${cssVariables.layout.inner.padding.sm}`,
    },

    [getMediaQuery('md')]: {
      maxWidth: `calc(240px + (${cssVariables.layout.inner.padding.md} * 2))`,
      padding: `0 ${cssVariables.layout.inner.padding.md}`,
    },
  },
})

export const layoutPopupMessage_container = style({})

export const layoutPopupMessage_items = style({
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  columnGap: 0,
  rowGap: 8,
})

export const layoutPopupMessage_item = style({})

export const layoutPopupMessage_contents__success = style({})

export const layoutPopupMessage_contents__error = style({})

export const layoutPopupMessage_contents = style({
  fontSize: getFontSize(14),
  borderRadius: 4,
  padding: '8px 16px',
  backgroundColor: cssVariables.color.shamrockDark.hex,
  color: cssVariables.color.white.hex,
  boxShadow: `0 2px 5px ${getRgba(cssVariables.color.black.rgb, 0.16)}`,

  selectors: {
    [`&${layoutPopupMessage_contents__error}`]: {
      backgroundColor: cssVariables.color.guardsmanRed.hex,
    },
  },
})

export const layoutPopupMessage_text = style({})
